export const getIbsCbsWarningTitle = (): string => {
  return 'Atenção, existem produtos sem IBS/CBS informado.';
};

export const getIbsCbsSubtitle = (): string => {
  const year = new Date().getFullYear();
  return year >= 2026
    ? ''
    : 'Regularize seu cadastro para evitar transtornos a partir de 2026.';
};
